import React, { useState } from 'react';
import ModalShell from '../ModalShell/ModalShell';
import { useI18n } from '../../i18n/I18nContext';
import './DenyAccessReasonModal.css';

interface DenyAccessReasonModalProps {
  loading?: boolean;
  onCancel: () => void;
  onSubmit: (reason: string) => void;
}

export default function DenyAccessReasonModal({
  loading = false,
  onCancel,
  onSubmit,
}: DenyAccessReasonModalProps) {
  const { t } = useI18n();
  const [reason, setReason] = useState('');

  return (
    <ModalShell
      onClose={onCancel}
      ariaLabel={t('presence.denyReasonTitle')}
      className="modal deny-access-reason-modal"
    >
      <div className="deny-access-reason-modal__content">
        <h3>{t('presence.denyReasonTitle')}</h3>
        <p>{t('presence.denyReasonMessage')}</p>
        <label htmlFor="deny-access-reason">{t('presence.denyReasonLabel')}</label>
        <textarea
          id="deny-access-reason"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          rows={4}
          placeholder={t('presence.denyReasonPlaceholder')}
          disabled={loading}
        />
        <div className="deny-access-reason-modal__actions">
          <button type="button" className="secondary" onClick={onCancel} disabled={loading}>
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="danger"
            onClick={() => onSubmit(reason.trim())}
            disabled={loading || !reason.trim()}
          >
            {t('presence.denyRequest')}
          </button>
        </div>
      </div>
    </ModalShell>
  );
}
